<template>
    <div>
        <div v-if="loading" class="lds-dual-ring"></div>
        <div class="row" v-if="!loading">
            <div class="col-lg-12 mb-4">
                <ClientInfoBlock
                    :client="dataInfoBlock"
                ></ClientInfoBlock>
            </div>
            <div class="col-lg-12 mb-4">
                <ClientTabsContainer
                    :client="client"
                ></ClientTabsContainer>
            </div>
        </div>
    </div>


</template>

<script>
import ClientInfoBlock from "./ClientInfoBlock.vue";
import ClientTabsContainer from "./ClientTabsContainer.vue";
import SiteClientsService from "./services/SiteClientsService";

export default {
    name: 'ClientPage',
    props: {
       client_id: {
           type: Number,
           required: true,
       }
    },
    components: {
        ClientTabsContainer,
        ClientInfoBlock
    },
    data() {
        return {
            loading: true,
            client: {},
            dataInfoBlock: {
                address: null,
                name: null,
                city: null,
                state: null,
                status: 'active'
            }

        }
    },
    methods: {
        async getUserInfo() {
            try {
                const {data: clientInfo} = await SiteClientsService.getClientInfo(this.client_id)
                this.client = clientInfo
                this.loading = false

                Object.keys(this.dataInfoBlock).forEach((key) => {
                    if (clientInfo.hasOwnProperty(key)) {
                        this.dataInfoBlock[key] = clientInfo[key];
                    }
                });
            } catch (error) {
                this.$handleErrors(error);
            }
        },
    },
    mounted() {
        this.getUserInfo()
    }
}

</script>

<style scoped>

</style>
